module.exports = __webpack_public_path__ + "img/email-icon.96b0ef0c.svg";